<div class="main-container">
  <div class="oportunidades-content row">
    <span style="font-size: large">
      Ingrese la información de la oportunidad comercial a consultar
    </span>
    <span style="font-size: medium; color: var(--mid-gray-color)">
      Recuerde que puede hacer la búsqueda general o por cualquier tipo de
      filtro.
    </span>
    <br /><br /><br />

    <form [formGroup]="frmOportunidades">
      <!-- DIV GENERAL -->
      <div class="form-container row">
        <!-- Primer DIV -->
        <div class="col-8">
          <div class="row">
            <!-- Tipo de Identificación -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Tipo de identificación</mat-label>
                <mat-select formControlName="tipo_identificacion">
                  <mat-option *ngFor="let t of tipo_id" [value]="t">
                    {{ t }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- No. de Identificación -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Número de identificación</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="identificacion"
                  maxlength="20"
                />
                <mat-error *ngIf="hasError(getControl['identificacion'])">
                  {{
                    printError(getControl["identificacion"], {
                      noSpaces: "No se permite espacios"
                    })
                  }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Estado de la Oportunidad -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Estado oportunidad comercial</mat-label>
                <mat-select formControlName="estado_oportunidad">
                  <mat-option *ngFor="let e of estados" [value]="e">
                    {{ e }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Fecha de creación -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field
                appearance="outline"
                style="width: 100%"
                floatLabel="always"
              >
                <mat-label>Fecha creación oportunidad comercial</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  placeholder="YYYY/MM/DD"
                  formControlName="fecha_creacion"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Fecha última gestión -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field
                appearance="outline"
                style="width: 100%"
                floatLabel="always"
              >
                <mat-label>Fecha última gestión</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  placeholder="YYYY/MM/DD"
                  formControlName="fecha_ultima_gestion"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Segundo DIV: Botones -->
        <div class="col-4">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <button
                type="submit"
                class="btn btn-primary btn-icon"
                (click)="consultar()"
                appTrackClick
                [trackData]="trackDataOportunidad"
              >
                <mat-icon>search</mat-icon><span>CONSULTAR</span>
              </button>
            </div>

            <div class="col-12 col-md-6 col-lg-5">
              <button
                type="button"
                class="btn btn-primary btn-icon"
                (click)="clear()"
              >
                <mat-icon>cancel</mat-icon><span>LIMPIAR</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- Resultados de la consulta -->
    <div *ngIf="haveResponde">
      <div class="mat-elevation-z8 col-12" [ngClass]="{ 'hide-table': !haveDataToShow }"
        style="display: flex; flex-direction: column; min-width: 300px">
        <mat-table [dataSource]="dsOportunidades" matSort>
          <ng-container [matColumnDef]="dt" *ngFor="let dt of attrData; let i = index">
            <mat-header-cell *matHeaderCellDef [mat-sort-header]="dt">
              {{ namesColumns[i] }}
            </mat-header-cell>
    
            <mat-cell class="break-word" *matCellDef="let element">
              <ng-container *ngIf="
                      dt === 'cumplimiento tiempos de gestión';
                      else normalCell
                    ">
                <span class="circle" [ngClass]="{
                        rojo: element[dt] === 'rojo',
                        amarillo: element[dt] === 'amarillo',
                        verde: element[dt] === 'verde',
                        negro: element[dt] === 'negro'
                      }" [matTooltip]="element[dt] | titlecase"></span>
              </ng-container>
    
              <ng-template #normalCell>
                {{ element[dt] }}
              </ng-template>
            </mat-cell>
          </ng-container>
    
          <mat-header-row *matHeaderRowDef="attrData"></mat-header-row>
    
          <mat-row *matRowDef="let row; columns: attrData"></mat-row>
        </mat-table>
    
        <mat-paginator *ngIf="haveDataToShow" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"
          showFirstLastButtons></mat-paginator>
    
        <!-- Hubo respuesta, pero no llegaron registros -->
        <div class="message-container" *ngIf="!haveDataToShow">
          <span class="message-span">
            {{ generalMessage.toUpperCase() }}
          </span>
        </div>
      </div>
    </div>
    
    <!-- No se obtuvo respuesta o ocurrió un error -->
    <div *ngIf="!haveResponde && generalMessage" class="message-container">
      <span class="message-span">
        {{ generalMessage.toUpperCase() }}
      </span>
    </div>
  </div>
</div>
